/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'human': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M896 383.915H640V938.58h-85.333v-256h-85.334v256H384V383.915H128V298.58h768M512 85.248a85.333 85.333 0 110 170.667 85.333 85.333 0 010-170.667z"/>'
  }
})
